import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import BGLogo from "../assets/images/123votelogo.png";

const homeActions = [
    {
        title: "Check your Registration Status",
        subtitle: "Not sure if you’re registered? Let’s check!",
    },
    {
        title: "Register to Vote",
        subtitle: "...In Less than 2 minutes!",
    },
    {
        title: "Check My Polling Location",
        subtitle: "Know where to go?",
    },
    {
        title: "Vote by Mail",
        subtitle: "Request to vote by mail on state site",
    },
    {
        title: "Get Election Reminders",
        subtitle: "Stay notified about election information",
    },
    // {
    //     title: "Get Involved!",
    //     subtitle: "Help us expand Democracy!",
    // },
];

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className="bg-slate-900 text-white min-h-screen">
            <main
                className="relative min-h-screen flex flex-col items-center justify-start pt-10"
                style={{ position: "relative" }}
            >
                {/* Faint background logo with overlay */}
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        zIndex: 0,
                        pointerEvents: "none",
                    }}
                >
                    <div
                    // style={{
                    //     width: "100vw",
                    //     height: "100vh",
                    //     // backgroundImage: `url(${BGLogo})`,
                    //     // backgroundRepeat: "repeat",
                    //     backgroundSize: "240px",
                    //     opacity: 0.03, // Adjust for faintness
                    //     filter: "blur(0.5px) grayscale(1)",
                    // }}
                    />
                </div>

                {/* Content */}
                <div className="relative z-10 w-full flex flex-col items-center">
                    <h1 className="text-white text-center text-2xl md:text-3xl font-bold mt-8 mb-14 drop-shadow-lg">
                        Scaling Democracy. Expanding the Electorate. Empowering Communities.
                    </h1>
                    <div className="w-full flex flex-col items-center space-y-8 max-w-md md:max-w-xl mx-auto">
                        {homeActions.map((action, idx) => (
                            <motion.button
                                key={idx}
                                className="w-full md:w-[480px] bg-white/90 text-black font-bold py-4 px-4 rounded-xl shadow-xl hover:shadow-2xl hover:bg-white transition flex flex-col items-center relative group"
                                initial={{ opacity: 0, y: 40 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    delay: idx * 0.08,
                                    type: "spring",
                                    stiffness: 170,
                                    damping: 18,
                                }}
                                whileHover={{
                                    scale: 1.04,
                                    boxShadow: "0 4px 40px 4px #6ee7b7",
                                    transition: { type: "spring", stiffness: 250 },
                                }}
                                onClick={() => {
                                    if (idx === 0 || idx === 1) {
                                        navigate("/check-registration");
                                    } else if (idx === 2) {
                                        navigate("/polling-location");
                                    } else if (idx === 3) {
                                        navigate("/vbm");
                                    } else if (idx === 4) {
                                        navigate("/reminder-subscription");
                                    }
                                    // Add more navigation logic for other buttons as you build them!
                                }}
                            >
                                <span className="text-lg md:text-xl flex items-center">
                                    {action.title}
                                    {/* Optional animated arrow */}
                                    <svg
                                        className="ml-2 group-hover:translate-x-2 transition-transform duration-200"
                                        width="18"
                                        height="18"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M5 12h14M13 5l7 7-7 7" />
                                    </svg>
                                </span>
                                <span className="text-sm font-normal">{action.subtitle}</span>
                            </motion.button>
                        ))}
                    </div>
                    {/* Spacer before footer */}
                    <div className="h-24" />
                </div>
            </main>

          
        </div>
    );
}
